import { useState, useEffect } from 'react'
import { videoViewIncrement } from '../apis/post/VideoAPI'

type useVideoViewIncrementProps = {
    isValidCount: boolean
    originalFile: string
    videoCurrentTime: number
}

export const useVideoViewIncrement = ( { isValidCount, originalFile, videoCurrentTime }: useVideoViewIncrementProps ) => {

    const [ alreadyIncremented, setAlreadyIncremented ] = useState( false );

    useEffect( () => {
        setAlreadyIncremented( false )
    }, [ originalFile ] )

    useEffect( () => {
        if ( !isValidCount ) return
        if ( !alreadyIncremented && originalFile && 1 < videoCurrentTime ) {
            viewIncrement()
            setAlreadyIncremented( true )
        }
    }, [ originalFile, videoCurrentTime ] )

    const viewIncrement = async () => {
        try {
            await videoViewIncrement( { videoURL: originalFile } )
        }
        catch ( e ) {
            console.log( e )
        }
    }
}
